import { ChargingSession } from '@api/ocpi';
import { ChargingSessionGrouped, ChargingSessionChargingDuration } from '../../../api/ocpp/api';

export interface Data {
  charger_id?: number;
  charger_name?: string;
  charger_derived_name?: string;
  charger_sticker_id?: string;
  session_count?: number;
  charging_duration?: ChargingSessionChargingDuration;
  energy_kwh?: string;
  earnings_cents?: number;
  end_transaction_timestamp?: string;
  start_transaction_timestamp?: string;
  vcr_id?: number;
}

const formatNum = (num: number) => {
  if (num < 10) return `0${num}`;
  return num;
}

function createData({ 
    charger_id,
    charger_name,
    charger_sticker_id,
    charger_derived_name,
    vcr_id,
    session_count,
    charging_duration,
    energy_kwh,
    earnings_cents,
    end_transaction_timestamp,
    start_transaction_timestamp,
  }: ChargingSession) {
  return {
    charger_id,
    charger_name,
    charger_sticker_id,
    session_count,
    charging_duration: `${charging_duration?.hours ? formatNum(charging_duration.hours) : '00'}:${charging_duration?.minutes ? formatNum(charging_duration.minutes) : '00'}:${charging_duration?.seconds ? formatNum(charging_duration.seconds) : '00'}`,
    energy_kwh: parseFloat(Number(energy_kwh).toFixed(2)),
    earnings_cents: `$${(earnings_cents / 100).toFixed(2)}`,
    charger_derived_name,
    vcr_id,
    end_transaction_timestamp,
    start_transaction_timestamp,
  };
}

interface TableDataProps {
  chargers: ChargingSession[];
}

export function TableData({ chargers = [] }: TableDataProps) {
  return chargers.map((c: ChargingSession) => {
   

    return createData(c);
  });
}
